

<template>
  <div class="second-footer">
    <div class="container d-flex align-items-center js-center">
      <div class="d-flex align-items-center">
        <img src="../assets/images/nav/aqbh.png" alt="">
        <div class="text">
          <div class="title">安全保护</div>
          <div class="sub-title">保护您的信息安全</div>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <img src="../assets/images/nav/gxzy.png" alt="">
        <div class="text">
          <div class="title">高效专业</div>
          <div class="sub-title">行业500+专业人士为你服务</div>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <img src="../assets/images/nav/zyqm.png" alt="">
        <div class="text">
          <div class="title">资源全面</div>
          <div class="sub-title">实时更新全国信息</div>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <img src="../assets/images/nav/qwrz.png" alt="">
        <div class="">
          <div class="title">权威认证</div>
          <div class="sub-title">中国招标网服务平台合作单位</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data(){
      return {

      }
    }
  }
</script>
<style scoped lang="scss">
.second-footer{
  background-color: #1565F7;
  padding: 10px;
  .container{
    img{
      width: 50px;
      height: 50px;
      margin-right: 8px;
    }
    .text{
      margin-right: 80px;
    }
    .title{
      font-weight: 400;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 28px;
    }
    .sub-title{
      font-weight: 400;
      font-size: 12px;
      color: #FFFFFF;
      line-height: 28px;
      text-align: center;
    }
  }
}
</style>
